// extracted by mini-css-extract-plugin
export default {"protected-route-root":"ProtectedRoute_protected-route-root__2H+RD"};